import React, { Fragment } from "react";
import useStyles from "./styles";
import {
  Button,
  Typography,
  DialogContent,
  DialogActions,
  Dialog,
  Box,
} from "@material-ui/core";
import LoadingWidget from "Components/widgets/LoadingWidget";
import CheckboxWithLabel from "Components/formControls/CheckboxWithLabel";

const ConfirmationModal = ({
  loader,
  open,
  fullWidth = true,
  size = "xs",
  buttonText = { okButton: "Ok", cancelButton: "Cancel" },
  title = "",
  body = "",
  formContent = "",
  isManagePermission = false,
  handleClose,
  handleOk,
  handleCheckbox,
  isDownload = false,
  isChecked = false,
  icon,
  bodySubtitle

}) => {
  const classes = useStyles();

  return (
    <Fragment>
      <Dialog
        disableBackdropClick
        className={classes.smallDialog}
        fullWidth={fullWidth}
        maxWidth={size}
        open={open}
        onClose={() => handleClose?.()}
      >
        <DialogContent className={classes.confirmationModalContent}>
          <Typography variant="subtitle1" className={classes.confirmationTitle}>
            {title}
          </Typography>
          {icon ? <div className={classes.dialogIcon}>{icon}</div> : null}
          {body && (
            <Box>
              <Typography variant="subtitle2" className={classes.contentBody}>
                {body}
              </Typography>
              {bodySubtitle &&
              <Typography variant="body2" className="font-13 f-light-gray">
                {bodySubtitle} 
              </Typography>}
            </Box>
          )}
          {isDownload && (
            <Box className={classes.modalCheckbox}>
              <CheckboxWithLabel
                label={"Include attachments"}
                checked={isChecked}
                handleChange={() => handleCheckbox && handleCheckbox()}
              />
            </Box>
          )}
        </DialogContent>

        <DialogActions className={classes.dialogActions}>
          <Button
            data-testid="handleclose"
            onClick={() => handleClose?.()}
            color="primary"
          >
            {buttonText.cancelButton}
          </Button>
          {!isManagePermission ? (
            <Button
              data-testid="handleok"
              onClick={() => handleOk?.()}
              color="primary"
              variant="contained"
              disabled={loader}
            >
              {loader ? <LoadingWidget color="white" /> : buttonText.okButton}
            </Button>
          ) : (
            ""
          )}
        </DialogActions>

        {formContent && (
          <div className={classes.dialogContent}>{formContent}</div>
        )}
      </Dialog>
    </Fragment>
  );
};

export default ConfirmationModal;
